import { render, staticRenderFns } from "./EventInfo.vue?vue&type=template&id=3b55166b&scoped=true&"
import script from "./EventInfo.vue?vue&type=script&lang=js&"
export * from "./EventInfo.vue?vue&type=script&lang=js&"
import style0 from "./EventInfo.vue?vue&type=style&index=0&id=3b55166b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b55166b",
  null
  
)

export default component.exports